import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getLocations({page, limit, search, details}) {
	return async dispatch => {
		if (!details) {
			const optionsQuery = [`page=${page}`, `limit=${limit}`];
			dispatch(push(`/locations?${optionsQuery.join('&')}`));
		}

		dispatch({
			type: ActionTypes.GET_LOCATION_PAGE_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.location.getLocations({
			page,
			limit,
			search: search ? JSON.stringify(search) : ''
		});

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_LOCATION_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_LOCATION_PAGE_SUCCESS,
			payload: {
				locations: response.data.locations,
				page: response.data.page,
				limit: response.data.limit,
				total: response.data.total,
				count: response.data.count,
				loading: false
			}
		});
	};
}

export function getFilteredLocations({ page, limit, search }) {
	return async dispatch => {
		// Update Path
		const optionsQuery = [`page=${page}`, `limit=${limit}`];
		dispatch(push(`/locations?${optionsQuery.join('&')}`));

		dispatch({
			type: ActionTypes.GET_LOCATION_PAGE_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.location.getLocations({
			page,
			limit,
			search: search ? JSON.stringify(search) : ''
		});

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_LOCATION_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_LOCATION_PAGE_SUCCESS,
			payload: {
				filteredLocations: response.data.locations,
				page: response.data.page,
				limit: response.data.limit,
				total: response.data.total,
				count: response.data.count,
				loading: false,
				search: search ? search : null
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_LOCATION_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_LOCATION_PAGE
		});
	};
}
